import { useDispatch, useSelector } from "react-redux";
import Types from "Types";
import {
  ActionCreators as AdbActionCreators,
  Selectors as AdbSelectors,
} from "../../../redux/AdministrateurDeBien";
import { ActiverAdb } from "../../../services/Api/AdministrateursDeBiens";
import { getUsername } from "../../../services/Authentification/authentification";
import {
  useActiverAdb,
  useDesactiverAdb,
} from "../../../hooks/AdministrateurDeBien";
import { Selectors } from "../../../redux/Utilisateurs";

export const useConsulterAdb = () => {
  // GET REDUCERS INFO
  const adbDetail = useSelector((state: Types.RootState) =>
    AdbSelectors.getADBDetail(state)
  );
  const adbId = useSelector((state: Types.RootState) =>
    AdbSelectors.getAdbId(state)
  );
  const username = useSelector((state: Types.RootState) => getUsername());
  const activerFetching = useSelector((state: Types.RootState) =>
    AdbSelectors.activerAdbFetching(state)
  );
  const activerError = useSelector((state: Types.RootState) =>
    AdbSelectors.activerAdbError(state)
  );
  const adbFetching = useSelector((state: Types.RootState) =>
    AdbSelectors.getADBFetching(state)
  );
  const adbError = useSelector((state: Types.RootState) =>
    AdbSelectors.getADBError(state)
  );

  const infoProfil = useSelector((state: Types.RootState) =>
    Selectors.getProfilUtilisateur(state)
  );
  const {
    mutate: mutateActiverAdb,
    isLoading: fetchingActiverAdb,
    error: errorAdbActiver,
  } = useActiverAdb();

  const {
    mutate: mutateDesactiverAdb,
    isLoading: fetchingDesactiverAdb,
    error: errorDesactiver,
  } = useDesactiverAdb();

  const dispatch = useDispatch();
  // GET ACTIONS
  const activerAdb = (params: ActiverAdb) => mutateActiverAdb(params);
  const desactiverAdb = (params: number) => mutateDesactiverAdb(params);
  const emptyErrorMessages = () =>
    dispatch(AdbActionCreators.emptyErrorMessages());

  return {
    adbDetail,
    adbId,
    username,
    fetchingActiverAdb,
    fetchingDesactiverAdb,
    errorDesactiver,
    errorAdbActiver,
    adbError,
    adbFetching,
    activerAdb,
    desactiverAdb,
    emptyErrorMessages,
    infoProfil,
  };
};
